import React from 'react'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>
          <strong>NASA PROJECTS - 2020 - SEI47</strong>
        </p>
      </div>
    </footer>
  )
}

export default Footer